import MinimizeButton from "../atoms/buttons/MinimizeButton.jsx";
import CloseButton from "../atoms/buttons/CloseButton.jsx";
import TaxlabLogo from "../atoms/images/TaxlabLogo.jsx";
import { ResizeIcon } from "../atoms/images/ResizeIcon.jsx";

export default function Header () {

    return (
        <div className="header">
					
					<div className="header-logo">
						<div className="header-resize-icon">
							<ResizeIcon/>
						</div>
						<div style={{paddingLeft:10}}>
							<TaxlabLogo/>
						</div>
					</div>
					<div className="header-buttons">
						<MinimizeButton/>
						<CloseButton/>
					</div>
        </div>
    );
};
